"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const authenticated_client_1 = require("./authenticated.client");
class MetricsClient extends authenticated_client_1.AuthenticatedClient {
    constructor() {
        super(...arguments);
        this.formatDateWithTimezone = true;
    }
    getMetric(projectId, body) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/metrics`, body);
            return response.payload;
        });
    }
    getHistogram(projectId, body) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/metrics/chart`, body);
            return response.payload;
        });
    }
    getDashboardMetrics(ac) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${ac.project}/metrics/dashboard?from=${ac.from.toISOString()}&to=${ac.to.toISOString()}` +
                `&goal=${ac.goal}&segments=${ac.segments.join(',')}&segmentInclude=${ac.segmentInclude}&device=${ac.device}&toCurrency=${ac.toCurrency}`;
            const response = yield this.httpGet(url);
            response.payload.conversions.forEach(i => (i.date = new Date(i.date)));
            return response.payload;
        });
    }
    getPagesMetrics(ac) {
        return __awaiter(this, void 0, void 0, function* () {
            const { project, from, to, device, pages, metrics, goal, includeSegmentIds, excludeSegmentIds } = ac;
            const req = { project, from, to, device, pages, metrics, goal, includeSegmentIds, excludeSegmentIds };
            const url = `/v1/projects/${ac.project}/metrics/pages?` + this.getQueryString(req);
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getExposures(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { project, from, to, device, page, goal, segments, segmentInclude, midZoneHeights } = request;
            const req = { project, from, to, device, page, goal, segments, segmentInclude, midZoneHeights };
            const url = `/v1/projects/${req.project}/metrics/exposures?` + this.getQueryString(req);
            const response = yield this.httpGet(url);
            if (Array.isArray(midZoneHeights)) {
                return response.payload;
            }
            return response.payload[0];
        });
    }
    getZoningMetrics(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${payload.project}/metrics/zoning`;
            const response = yield this.httpPost(url, payload);
            return response.payload || [];
        });
    }
    getZonesMetrics(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryString = Array.isArray(request.metrics) ? { metrics: request.metrics } : { metricType: request.metrics };
            delete request.metrics;
            const url = `/v1/projects/${request.project}/metrics/zones?` + this.getQueryString(queryString);
            const response = yield this.httpPost(url, request);
            return response.payload;
        });
    }
    getPageViews(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { project } = payload, params = __rest(payload, ["project"]);
            const url = `/v1/projects/${project}/metrics/total-views`;
            const response = yield this.httpPost(url, params);
            return {
                pageId: payload.pageId || payload.aliasId,
                urlRegex: payload.urlRegex,
                totalViews: response.payload ? response.payload.totalViews : null,
            };
        });
    }
    getUrlsMetricsList(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { project } = payload, params = __rest(payload, ["project"]);
            const url = `/v1/projects/${project}/metrics/urls`;
            const response = yield this.httpPost(url, params);
            return response.payload || [];
        });
    }
    getPageMetrics(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${request.project}/metrics/page?from=${request.from.toISOString()}` +
                `&to=${request.to.toISOString()}&device=${request.device}&segments=${request.segments.join(',')}` +
                `&segmentInclude=${request.segmentInclude}&page=${request.page}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getFoldHeight(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const segments = request.segments && request.segments.length ? request.segments : [-1];
            const segmentInclude = request.segmentInclude === false ? false : true;
            const url = `/v1/projects/${request.project}/metrics/foldheight?from=${request.from.toISOString()}` +
                `&to=${request.to.toISOString()}&device=${request.device}&segments=${segments.join(',')}` +
                `&page=${request.page}&segmentInclude=${segmentInclude}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getNavigationTree(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${request.project}/metrics/navigation-path?` +
                this.getQueryString(Object.assign(Object.assign({}, request), { projects: undefined }));
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
}
exports.MetricsClient = MetricsClient;
//# sourceMappingURL=metrics.client.js.map